/* ================================================== */
/* OBJECT FIT IMAGES
/* ================================================== */

$(document).ready(function() {
	var $images = $('.object-fit-cover, .object-fit-contain');
	objectFitImages($images);
});